export default __webpack_public_path__ + "static/media/login_signup_background.e6e11d04.svg";